import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { NOTICE_SECTIONS } from "@/lib/privacyNotice";
import { AlertTriangle, ChevronLeft } from "lucide-react";

function Pending({ items, id }) {
  if (!items?.length) return null;
  return (
    <div className="mt-3 rounded-lg border border-amber-300 bg-amber-50 p-3 space-y-1.5" data-testid={`notice-pending-${id}`}>
      {items.map((t) => (
        <p key={t} className="flex gap-2 text-xs text-amber-900">
          <AlertTriangle className="w-4 h-4 shrink-0 mt-0.5" /><span><b>Pending verification:</b> {t}</span>
        </p>
      ))}
    </div>
  );
}

const List = ({ items }) => items?.length ? (
  <ul className="list-disc pl-5 space-y-1.5 text-sm text-slate-700">{items.map((t) => <li key={t}>{t}</li>)}</ul>
) : null;

function Section({ s }) {
  return (
    <section className="space-y-2.5" data-testid={`notice-section-${s.id}`} id={s.id}>
      <h2 className="font-serif text-lg text-[#0A1F44]">{s.title}</h2>
      {s.paras?.map((p) => <p key={p} className="text-sm text-slate-700 leading-relaxed">{p}</p>)}
      <List items={s.list} />
      {s.after?.map((p) => <p key={p} className="text-sm text-slate-700 leading-relaxed">{p}</p>)}
      <List items={s.list2} />
      <Pending items={s.pending} id={s.id} />
    </section>
  );
}

export default function PrivacyNotice() {
  const [meta, setMeta] = useState(null);
  useEffect(() => { api.get("/privacy/notice").then((r) => setMeta(r.data)).catch(() => {}); }, []);
  return (
    <div className="min-h-screen bg-[#F7F5EF]">
      <div className="max-w-2xl mx-auto px-5 py-8 sm:py-12" data-testid="privacy-notice-page">
        <Link to="/" className="text-sm text-slate-500 inline-flex items-center gap-1 hover:text-slate-800" data-testid="privacy-back-link">
          <ChevronLeft className="w-4 h-4" /> Team Smith Hub
        </Link>
        <div className="text-[11px] uppercase tracking-[0.24em] text-[#C9A961] font-semibold mt-6">Privacy</div>
        <h1 className="font-serif text-3xl sm:text-4xl text-[#0A1F44] mt-1">Team Smith Hub Privacy Notice</h1>
        <p className="text-sm text-slate-500 mt-2" data-testid="privacy-last-updated">Last updated: {meta?.last_updated || "25 October 2026"}</p>
        <div className="mt-4 rounded-xl border-2 border-dashed border-amber-400 bg-amber-50 px-4 py-3 text-sm text-amber-900" data-testid="privacy-draft-banner">
          <b>Preview draft — technical details pending verification.</b> This is not a final, legally reviewed policy.
          {meta?.version && <span className="block text-xs mt-1">Version {meta.version}</span>}
        </div>
        <div className="mt-8 space-y-8 bg-white rounded-2xl border border-slate-200 p-5 sm:p-8">
          {NOTICE_SECTIONS.map((s) => <Section key={s.id} s={s} />)}
        </div>
      </div>
    </div>
  );
}
